<template>
    <div class="remarks-box">
        <!-- 备忘录 -->
        <div class="remarks-box-title  mb-40">
            <div class="title-box  flex-row justify-between ">
                <div class="black font34 bold">备忘录</div>
                <div class="add-box flex-col">
                    <div class="add-img-box flex-row justify-between" @click="toAddRemarks(custId,name)">
                        <img class="thumbnail_1" referrerpolicy="no-referrer" alt=""
                            src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/add.png" />
                        <span class="add-title">新增</span>
                    </div>
                </div>
            </div>
        </div>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="20"
            :immediate-check="false">
            <div class="main-remarks" v-for="(item, index) in remarksList" :key="index">
                <div class="remarks-title ">
                    <div class="fl  date">{{ item.createDate }}</div>
                    <div v-if="item.delStatus==1" class="fr middle" @click="toDeleteDiary(item.id)">
                        <img class="remarks-icon middle" referrerpolicy="no-referrer" alt=""
                            src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/delete.png" />
                    </div>
                </div>
                <div class="remarks-store">
                    记录门店：{{item.storeName}}
                </div>
                <div class="remarks-contents">{{item.createName}}记录：{{item.remark}}</div>
            </div>
        </van-list>
    </div>
</template>

<script>
import request from "@/utils/request";
import { Dialog } from "vant";
export default {
    name: 'remarks',
    components: {

        [Dialog.name]: Dialog,
    },
    props: {
        custId: {
            type: String,
        },
        name: {
            type: String,
        },
        phone: {
            type: String,
        },
    },
    data() {
        return {
            list: [],
            // name: "",
            // phone: "",
            page: 1,
            total: 0,
            remarksList: [],
            loading: true, //list
            finished: false, //list
        };
    },
    mounted() {
        this.onLoad();

    },
    methods: {
        // 列表上拉加载
        onLoad() {
            const limit = 10
            request({
                url: `/custRemark/getPage?custId=${this.custId}&limit=${limit}&page=${this.page}`,
                method: "get",
            })
                .then((res) => {
                    this.remarksList = this.page == 1 ? res.data.list : this.remarksList.concat(res.data.list);
                    this.page += 1;
                    if (res.data.list && res.data.list.length < limit) {
                        this.finished = true;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        toAddRemarks(custId, name) {
            this.$router.push({ name: "addRemarks", query: { custId: custId, name: name, phone: this.phone } });
        },

        toDeleteDiary(id) {
            Dialog.confirm({
                title: "删除备注",
                message: `是否确认删除该备注`,
                confirmButtonColor: '#3fb8e2'
            }).then(() => {
                request({
                    url: `/custRemark/${id}`,
                    method: "get",
                })
                    .then(() => {
                        this.$toast({
                            message: "删除成功",
                        });
                        this.page = 1;
                        this.onLoad();
                    })
                    .finally(() => {
                    });
            }).catch(() => {
            })
        }
    },
};
</script>
<style scoped>
.black {
    color: #35434c;
}
.date {
    width: 242px;
    height: 40px;
    display: inline-block;
    overflow-wrap: break-word;
    color: rgba(160, 172, 181, 1);
    font-size: 28px;
    white-space: nowrap;
    line-height: 40px;
    text-align: left;
}
.remarks-store {
    width: 392px;
    height: 40px;
    display: inline-block;
    overflow-wrap: break-word;
    color: rgba(53, 67, 76, 1);
    font-size: 28px;
    white-space: nowrap;
    line-height: 40px;
    text-align: left;
    margin-top: 31px;
}

.remarks-box {
    width: 100%;
    height: 100%;
    background-color: #fff;
    margin-top: 40px;
}
.remarks-box-title {
    justify-content: flex-start;
    align-items: center;
}

.remarks-box-title.icon {
    width: 40px;
    height: 40px;
}

.main-consume {
    width: 690px;
    background: #ffffff;
    box-sizing: border-box;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
}

.remarks-icon {
    width: 34px;
    height: 34px;
    margin-top: -15px;
}
.main-remarks {
    width: 690px;
    height: 100%;
    background: #ffffff;
    box-shadow: 0px 2px 26px 0px rgba(2, 2, 2, 0.08);
    border-radius: 30px;
    padding: 40px 30px;
    margin-bottom: 30px;
}
.remarks-title {
    width: 100%;
    height: 46px;
    line-height: 46px;
}

.remarks-contents {
    margin-top: 30px;
    width: 630px;
    font-size: 28px;
    font-weight: 400;
    color: #6c7d87;
    line-height: 40px;
}

.add-box {
    height: 50px;
    border-radius: 25px;
    background-color: rgba(47, 208, 213, 1);
    width: 118px;
    margin-left: 450px;
}

.add-img-box {
    width: 78px;
    height: 33px;
    margin: 9px 0 0 20px;
}

.thumbnail_1 {
    width: 20px;
    height: 20px;
    margin-top: 6px;
}

.add-title {
    width: 48px;
    height: 33px;
    display: inline-block;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 24px;
    white-space: nowrap;
    line-height: 33px;
    text-align: left;
    margin-left: 5px;
}
</style>
